<template>
    <div id="pageDashboard" v-if="hasPermission('STATS') || hasPermission('ADMIN_STATS')">
        <v-tabs
                centered
                color="cyan"
                dark
                icons-and-text
        >

            <v-tabs-slider color="yellow"></v-tabs-slider>

            <v-tab href="#basics" v-if="hasPermission('STATS')">
                Basic
                <v-icon>
                    fa fa-eye
                </v-icon>
            </v-tab>

            <v-tab href="#weekly_financial" v-if="hasPermission('WEEKLY_FINANCIAL_STATS')">
                Financial
                <v-icon>
                    attach_money
                </v-icon>
            </v-tab>

            <v-tab href="#passengers" v-if="hasPermission('PASSENGERS_STATS')">
                Passengers
                <v-icon>
                    fa fa-user-o
                </v-icon>
            </v-tab>

            <v-tab href="#captains" v-if="hasPermission('CAPTAIN_STATS')">
                Captains
                <v-icon>
                    fa fa-user-secret
                </v-icon>
            </v-tab>

            <v-tab href="#mixed" v-if="hasPermission('MIXED_STATS')">
                Mixed
                <v-icon>
                    fa fa-random
                </v-icon>
            </v-tab>

            <v-tab href="#osm" v-if="hasPermission('OSM_STATS')">
                OSM
                <v-icon>
                    map
                </v-icon>
            </v-tab>

            <v-tab-item
                    value="basics"
                    lazy>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Signups today">
                                <div slot="widget-content" class="headline text-xs-center">
                                    {{stats.signUpsToday}}
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Approved passengers today">
                                <div slot="widget-content" class="headline text-xs-center">
                                    {{stats.approvedPassengersToday}}
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Unapproved passengers ever">
                                <div slot="widget-content" class="headline text-xs-center">
                                    {{stats.unApprovedPassengersEver}}
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Unapproved passengers today">
                                <div slot="widget-content">
                                    <unapproved-passengers-pie-chart
                                            v-if="stats.unApprovedPassengersWithIdsToday > 0 || stats.unApprovedPassengersWithoutIdsToday"
                                            :un-approved-passengers-with-ids-today="stats.unApprovedPassengersWithIdsToday"
                                            :un-approved-passengers-without-ids-today="stats.unApprovedPassengersWithoutIdsToday"
                                    />
                                    <div v-else class="headline text-xs-center">
                                        0
                                    </div>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Bookings Count Yesterday">
                                <div slot="widget-content" class="headline text-xs-center">
                                    <non-pooling-vs-pooling-bookings-pie-chart
                                            v-if="stats.bookingsYesterdayPerService && stats.bookingsYesterdayPerService.reduce( (sum,r) => sum + r.value,0) > 0"
                                            :value="stats.bookingsYesterdayPerService"
                                    />
                                    <div v-else class="headline text-xs-center">
                                        0
                                    </div>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Incomplete bookings yesterday">
                                <div slot="widget-content" class="headline text-xs-center">
                                    <rejected-vs-cancelled-bookings-pie-chart
                                            v-if="stats.rejectedBookingsYesterday > 0 || stats.cancelledBookingsYesterday > 0"
                                            :rejected-bookings="stats.rejectedBookingsYesterday"
                                            :cancelled-bookings="stats.cancelledBookingsYesterday"
                                            :all-bookings-count="stats.allBookingsYesterday"
                                    />
                                    <div v-else class="headline text-xs-center">
                                        0
                                    </div>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-widget title="Average Rating Today">
                                <div slot="widget-content" class="headline text-xs-center">
                                    <template v-if="stats.averageRatingToday !== null">
                                        {{stats.averageRatingToday}}
                                    </template>
                                    <template v-else>
                                        No Ratings Today
                                    </template>
                                </div>
                            </v-widget>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item
                    v-if="hasPermission('WEEKLY_FINANCIAL_STATS')"
                    value="weekly_financial"
                    lazy>
                <v-container grid-list-xl fluid>
                    <loading-component :value="loading"></loading-component>
                    <choose-date v-model="date"></choose-date>
                    <h1 style="text-align: center">Weekly Financial</h1>
                    <v-layout style="margin: 15px" row wrap>
                        <v-flex xs6><h2 style="text-align: center">From: {{financial_stats.period[0]}}</h2></v-flex>
                        <v-flex xs6><h2 style="text-align: center">To: {{financial_stats.period[1]}}</h2></v-flex>
                    </v-layout>
                    <v-layout style="margin: 15px" row wrap>
                        <v-flex xs4><h3 style="text-align: center">Revenue: {{financial_stats.revenue}}</h3></v-flex>
                        <v-flex xs4><h3 style="text-align: center">Fee: {{financial_stats.fee}}</h3></v-flex>
                        <v-flex xs4><h3 style="text-align: center">Payroll: {{financial_stats.payroll}}</h3></v-flex>
                    </v-layout>
                    <v-layout style="margin: 15px" row wrap>
                        <v-flex xs4><h3 style="text-align: center">Discount: {{financial_stats.discount}}</h3></v-flex>
                        <v-flex xs4><h3 style="text-align: center">Refund: {{financial_stats.refund}}</h3></v-flex>
                        <v-flex xs4><h3 style="text-align: center">Penalties: {{financial_stats.penalties}}</h3>
                        </v-flex>
                    </v-layout>
                    <v-layout style="margin: 15px" row wrap>
                        <v-flex xs6><h3 style="text-align: center">Bonus captain: {{financial_stats.bonus_captain}}</h3>
                        </v-flex>
                        <v-flex xs6><h3 style="text-align: center">Bonus passenger:
                            {{financial_stats.bonus_passenger}}</h3></v-flex>
                    </v-layout>
                    <v-layout style="margin: 15px" row wrap>
                        <v-flex xs12><h1 style="text-align: center">Profit: {{ financial_stats.profit }}</h1></v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item
                    v-if="hasPermission('PASSENGERS_STATS')"
                    value="passengers"
                    lazy>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-widget title="Customizations">
                                <v-layout slot="widget-content">
                                    <v-flex xs12 md4>
                                        <v-select
                                                :items="groupByOptions"
                                                label="Group By"
                                                v-model="groupBy"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <ChooseDate clearable v-model="startDate" label="Start Date"/>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <ChooseDate clearable v-model="endDate" label="End Date"/>
                                    </v-flex>
                                </v-layout>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Bookings">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.bookingsCountPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :default-group-by="groupBy"
                                                     :border-colors="['#FFF']"
                                                     :labels="['Bookings Count']"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                    />
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Successful Bookings">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.successfulBookingsCountPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :default-group-by="groupBy"
                                                     :border-colors="['#FFF']"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     :labels="['Bookings Count']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Rejected Bookings">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.rejectedBookingsCountPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :border-colors="['#FFF']"
                                                     :default-group-by="groupBy"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     :labels="['Bookings Count']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Acquired vs Approved Passengers">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.acquiredPassengersPerDay,stats.approvedPassengersPerDay]"
                                            :background-colors='["#0cb","#0fb"]'
                                            :default-group-by="groupBy"
                                            :border-colors="['#FFF','#FFF']"
                                            stacked
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            :labels="['Acquired Passengers','Approved Passengers']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Active Passengers">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.activePassengersPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :can-group-by="false"
                                                     :border-colors="['#FFF']"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     :labels="['Active Passengers']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Passengers(month) (Booking Datetime)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constPassengersPerMonthDatetime,stats.returningPassengersPerMonthDatetime,
                                            stats.newPassengersPerMonthDatetime,stats.lostPassengersPerMonthDatetime]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Passengers(week) (Booking Datetime)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constPassengersPerWeekDatetime,stats.returningPassengersPerWeekDatetime,
                                            stats.newPassengersPerWeekDatetime,stats.lostPassengersPerWeekDatetime]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Passengers(month) (Booking Creation)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constPassengersPerMonthCreation,stats.returningPassengersPerMonthCreation,
                                            stats.newPassengersPerMonthCreation,stats.lostPassengersPerMonthCreation]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Passengers(week) (Booking Creation)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constPassengersPerWeekCreation,stats.returningPassengersPerWeekCreation,
                                            stats.newPassengersPerWeekCreation,stats.lostPassengersPerWeekCreation]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item
                    v-if="hasPermission('CAPTAIN_STATS')"
                    value="captains"
                    lazy>
                <v-container grid-list-xl fluid>

                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-widget title="Customizations">
                                <v-layout slot="widget-content">
                                    <v-flex xs12 md4>
                                        <v-select
                                                :items="groupByOptions"
                                                label="Group By"
                                                v-model="groupBy"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <ChooseDate clearable v-model="startDate" label="Start Date"/>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <ChooseDate clearable v-model="endDate" label="End Date"/>
                                    </v-flex>
                                </v-layout>
                            </v-widget>
                        </v-flex>

                        <v-flex lg3 md4 sm12>
                            <v-widget title="Captains first ride">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.captainsWhoMadeTheirFirstBookingPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :default-group-by="groupBy"
                                                     :border-colors="['#FFF']"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     :labels="['Captains Count']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Ghost vs Meter Ride">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.avgGhostRidesPerDay,stats.avgMeterRidesPerDay]"
                                                     :background-colors='["#0cb","#0fb"]'
                                                     :border-colors="['#FFF','#FFF']"
                                                     :default-group-by="groupBy"
                                                     group-function="avg"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     stacked
                                                     :labels="['Avg Ghost Ride','Avg Meter Ride']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Acquired vs Approved Captains">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.acquiredCaptainsPerDay,stats.approvedCaptainsPerDay]"
                                            :background-colors='["#0cb","#0fb"]'
                                            :default-group-by="groupBy"
                                            :border-colors="['#FFF','#FFF']"
                                            stacked
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            :labels="['Acquired Captains','Approved Captains']"/>

                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Active Captains">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.activeCaptainsPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :border-colors="['#FFF']"
                                                     :can-group-by="false"
                                                     stacked
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     :labels="['Active Captains']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg3 md4 sm12>
                            <v-widget title="Online Captains">
                                <div slot="widget-content">
                                    <BarWithGrouping :data="[stats.onlineCaptainsPerDay]"
                                                     :background-colors='["#0cb"]'
                                                     :border-colors="['#FFF']"
                                                     :can-group-by="false"
                                                     :initial-start-date="startDate"
                                                     :initial-end-date="endDate"
                                                     :labels="['Online Captains']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Captains(week) (CheckLog)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constCaptainsPerWeekCheckLog,stats.returningCaptainsPerWeekCheckLog,stats.newCaptainsPerWeekCheckLog,stats.lostCaptainsPerWeekCheckLog]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Captains(month) (CheckLog)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constCaptainsPerMonthCheckLog,stats.returningCaptainsPerMonthCheckLog,stats.newCaptainsPerMonthCheckLog,stats.lostCaptainsPerMonthCheckLog]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Captains(week) (Ride)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constCaptainsPerWeekRide,stats.returningCaptainsPerWeekRide,stats.newCaptainsPerWeekRide,stats.lostCaptainsPerWeekRide]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                        <v-flex lg4 md6 sm12>
                            <v-widget title="Captains(month) (Ride)">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.constCaptainsPerMonthRide,stats.returningCaptainsPerMonthRide,stats.newCaptainsPerMonthRide,stats.lostCaptainsPerMonthRide]"
                                            :background-colors='["#0FF","#0F8","#00F","#F00"]'
                                            :can-group-by="false"
                                            :border-colors="['#FFF','#FFF','#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            stacked
                                            :labels="['Const','Returning','New','Lost']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-tab-item>

            <v-tab-item
                    v-if="hasPermission('MIXED_STATS')"
                    value="mixed"
                    lazy
            >
                <v-container grid-list-xl fluid>

                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-widget title="Customizations">
                                <v-layout slot="widget-content">
                                    <v-flex xs12 md4>
                                        <v-select
                                                :items="groupByOptions"
                                                label="Group By"
                                                v-model="groupBy"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <ChooseDate clearable v-model="startDate" label="Start Date"/>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <ChooseDate clearable v-model="endDate" label="End Date"/>
                                    </v-flex>
                                </v-layout>
                            </v-widget>
                        </v-flex>

                        <v-flex lg3 md4 sm12>
                            <v-widget title="Avg Rating">
                                <div slot="widget-content">
                                    <BarWithGrouping
                                            :data="[stats.avgCaptainRatingPerDay,stats.avgPassengerRatingPerDay]"
                                            :background-colors='["#0cb","#0FF"]'
                                            :default-group-by="groupBy"
                                            group-function="avg"
                                            :border-colors="['#FFF','#FFF']"
                                            :initial-start-date="startDate"
                                            :initial-end-date="endDate"
                                            :labels="['Captain Rate','Passenger Rate']"/>
                                </div>
                            </v-widget>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item v-if="hasPermission('OSM_STATS')" value="osm" lazy>
                <v-container grid-list-xl fluid>
                    <osm-stats></osm-stats>
                </v-container>
            </v-tab-item>
        </v-tabs>

    </div>
</template>

<script>
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import moment from "moment";
    import UnapprovedPassengersPieChart from "@/components/widgets/statistic/UnapprovedPassengersPieChart";
    import NonPoolingVsPoolingBookingsPieChart
        from "@/components/widgets/statistic/NonPoolingVsPoolingBookingsPieChart";
    import RejectedVsCancelledBookingsPieChart from "@/components/widgets/statistic/RejetedVsCancelledBookingsPieChart";
    import BarWithGrouping from "@/components/widgets/statistic/BarWithGrouping";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import LoadingComponent from "@/components/LoadingComponent";
    import DataTable from "@/components/wasilni/DataTable";
    import OsmStats from "@/components/wasilni/OsmStats";

    export default {
        title: 'Dashboard',
        components: {
            OsmStats,
            DataTable,
            LoadingComponent,
            VWidget,
            UnapprovedPassengersPieChart,
            NonPoolingVsPoolingBookingsPieChart,
            RejectedVsCancelledBookingsPieChart,
            BarWithGrouping,
            ChooseDate
        },
        data() {
            return {
                groupBy: 'month',
                groupByOptions: ['day', 'week', 'month', 'quarter', 'year'],
                startDate: null,
                endDate: null,
                color: Material,
                date: '',
                loading: false,
                stats: {
                    unApprovedPassengersEver: 0,
                    unApprovedPassengersWithIdsToday: 0,
                    unApprovedPassengersWithoutIdsToday: 0,
                    approvedPassengersToday: 0,
                    signUpsToday: 0,
                    allBookingsYesterday: 0,
                    cancelledBookingsYesterday: 0,
                    poolingBookingsYesterday: 0,
                    rejectedBookingsYesterday: 0,
                    averageRatingToday: 0,
                    activeCaptainsPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    captainsWhoMadeTheirFirstBookingPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    acquiredCaptainsPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    approvedCaptainsPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    acquiredPassengersPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    approvedPassengersPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    activePassengersPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    avgGhostRidesPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    avgMeterRidesPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    avgPassengerRatingPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    avgCaptainRatingPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    onlineCaptainsPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    bookingsCountPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    successfulBookingsCountPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    rejectedBookingsCountPerDay: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningPassengersPerWeekDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newPassengersPerWeekDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constPassengersPerWeekDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostPassengersPerWeekDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningPassengersPerMonthDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newPassengersPerMonthDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constPassengersPerMonthDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostPassengersPerMonthDatetime: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningPassengersPerWeekCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newPassengersPerWeekCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constPassengersPerWeekCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostPassengersPerWeekCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningPassengersPerMonthCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newPassengersPerMonthCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constPassengersPerMonthCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostPassengersPerMonthCreation: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningCaptainsPerWeekCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newCaptainsPerWeekCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constCaptainsPerWeekCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostCaptainsPerWeekCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningCaptainsPerMonthCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newCaptainsPerMonthCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constCaptainsPerMonthCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostCaptainsPerMonthCheckLog: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningCaptainsPerWeekRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newCaptainsPerWeekRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constCaptainsPerWeekRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostCaptainsPerWeekRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    returningCaptainsPerMonthRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    newCaptainsPerMonthRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    constCaptainsPerMonthRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    lostCaptainsPerMonthRide: [{value: 0, date: moment().format("YYYY-MM-DD")}],
                    bookingsYesterdayPerService: [{service_id: 1, name: 'Pooling', value: 12}]
                },
                financial_stats: {
                    period: [this.moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), this.moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')]

                }
            };
        },
        methods: {
            getFinancialStats() {
                this.loading = true;
                this.axios.get(this.api.ACTIONS.STATISTICS).then(
                    ({data: {data}}) => {
                        this.stats = data;
                    }
                );
                this.axios.get('statistics/weekly_financial' + (this.date ? `?date=${this.date}` : ''))
                    .then((res) => {
                        this.financial_stats = Object.assign(this.financial_stats, res.data.data);
                        this.financial_stats.profit = parseInt(this.financial_stats.revenue) + parseInt(this.financial_stats.bonus_passenger)
                            + parseInt(this.financial_stats.fee) + parseInt(this.financial_stats.payroll) + parseInt(this.financial_stats.discount)
                            + parseInt(this.financial_stats.refund) + parseInt(this.financial_stats.bonus_captain) + parseInt(this.financial_stats.penalties);
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        },
        watch: {
            date() {
                this.getFinancialStats()
            }
        },
        mounted() {
            this.getFinancialStats();
        }
    };
</script>
